/** @jsx jsx */
import { Button, ButtonComponentProps, forwardRefWithAs, PropsWithAs } from "@eworkit/iris";
import React from "react";
import { jsx } from "theme-ui";

import { navItemsLinkStyles, navItemsStyles } from "./../config";

export interface NavLinkButtonComponentProps extends ButtonComponentProps {}

const NavLinkButtonComponent = (
  props: PropsWithAs<NavLinkButtonProps, "a">,
  forwardedRef: React.Ref<HTMLAnchorElement>,
) => {
  const { as: Component = "a", variant = "ghost", size = "lg", children, ...rest } = props;
  return (
    <Button
      sx={{ ...navItemsStyles, ...navItemsLinkStyles }}
      as={Component}
      size={size}
      variant={variant}
      display="inline-block"
      {...rest}
      ref={forwardedRef}>
      {children}
    </Button>
  );
};

export type NavLinkButtonProps = PropsWithAs<NavLinkButtonComponentProps, "a">;
export const NavLinkButton = forwardRefWithAs<NavLinkButtonComponentProps, "a">(NavLinkButtonComponent);
